import axios, { AxiosRequestConfig } from "axios";
import query from "./constants.api";

// const config : AxiosRequestConfig = {baseURL: 'https://jsonplaceholder.typicode.com'}
// export const axiosInstance = axios.create(config);

const axiosInstance = (method, url, data, params, type, baseUrl) => {
    const contentType = type ? type : 'application/x-www-form-urlencoded';

    const accessToken = 'Bearer ' + localStorage.getItem('sessionToken');
    const headers = {
        'content-type': contentType,
        Authorization: accessToken,
    };

    let config = {
        method: method ? method : 'GET',
        baseURL: baseUrl ? baseUrl : query.baseURL,
        url: url ? url : '',
        headers: headers,
        data: data ? data : null,
        params: params ? params : null,
    };

    return axios(config);
};

export default axiosInstance;
